module.exports = __webpack_public_path__ + "static/media/betsalel.049f9f00.jpg";